/**
 * Created by yarik on 18.7.17.
 */
import lazyLoading from './lazyLoading'

export default {
  name: 'driverCard',
  meta: {
    expanded: false,
    title: 'TARJETON',
    iconClass: 'vuestic-icon vuestic-icon-auth',
    isShareTrip: true,
  },
  children: [
    {
      name: 'driverCard',
      path: '/p1/:driverId',
      component: lazyLoading('config/DriverCard'),
      meta: {
        title: 'Tarjeton',
        requiresAuth: false,
        isShareTrip: true,
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/driverCard.js